import React from 'react';
import Modal from 'react-bootstrap/Modal'
import './ErrorPopup.scss';
import { Button } from '@activehub/common-components-spa';

export function ErrorPopUp(props) {

  return (
    <Modal dialogClassName="modal__dialog" show={props.isOpen} className="error-modal" centered aria-describedby="dialogbody" aria-labelledby="dialogheading">
      <Modal.Header className="modal__header" id="dialogheading">
        <img className='modal-img' src={`${process.env.PUBLIC_URL}/images/csv-warning-alert.svg`} />
        <Modal.Title className={props.titleClass || ''}><h2 className="h4">{props.headerText}</h2></Modal.Title>
      </Modal.Header>
      <Modal.Body className={`modal__body`} id="dialogbody">
        <div className="text-left content__p">
          <div dangerouslySetInnerHTML={{__html: props.bodyText}}></div>
        </div>  
          <Modal.Footer className="modal__footer">
           <Button className='modalbtn button__v2 ripple--v2 button__primary' value={props.closeButton} onClick={()=>{ props.handleCloseButton() }}/>
          </Modal.Footer>
      </Modal.Body>
    </Modal>
  )
}